import { useState } from 'react';
import { Create } from '@refinedev/antd';
import { message } from 'antd';
import { useNavigate } from 'react-router';
import { QuestionForm } from './QuestionForm';
import { createQuestion, QuestionPayload } from '../../api/discovery';

export function QuestionCreate() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(payload: QuestionPayload) {
    setSubmitting(true);
    try {
      await createQuestion(payload);
      message.success('Question created');
      navigate('/questions');
    } catch (err) {
      message.error((err as { message?: string }).message ?? 'Create failed');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Create title="New question" goBack={false} footerButtons={() => null}>
      <QuestionForm showDefault submitting={submitting} onSubmit={onSubmit} onCancel={() => navigate('/questions')} />
    </Create>
  );
}
